// extracted by mini-css-extract-plugin
export default {"card":"card--wN_u6","cardHeader":"cardHeader--gf5zY","cardTitle":"cardTitle--uAoyX","cardDescription":"cardDescription--vSQ0G","cardContent":"cardContent--tO_O8"};